import HACKSAWEGAMEActions from './HACKSAWEGAMEActions'

export default class HACKSAWSLOTActions extends HACKSAWEGAMEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'HACKSAW',
      gameType: 'SLOT',
      gameCode: 'HACKSAW-SLOT-070',
    }

    this.gameName = 'Wanted Dead or a Wild'
  }
}
